import { useWorkOrdersStore } from '../../store/workOrdersStore';
import { AddressCard } from './AddressCard';
import { LoadingSkeleton } from '../common/LoadingSkeleton';
import { ErrorState } from '../common/ErrorState';
import { EmptyState } from '../common/EmptyState';
import { WorkOrder } from '../../types/workOrders';

interface AddressListProps {
  showCompleted: boolean;
}

function groupByAddress(orders: WorkOrder[], filterCompleted: boolean) {
  const filteredOrders = orders.filter(
    (order) => filterCompleted ? 
      ['COMPLETED', 'REJECTED'].includes(order.status) : 
      !['COMPLETED', 'REJECTED'].includes(order.status)
  );

  const grouped = filteredOrders.reduce((acc, order) => {
    const key = order.address;
    if (!acc[key]) {
      acc[key] = {
        address: order.address,
        city: order.city,
        state: order.state,
        orders: [],
      };
    }
    acc[key].orders.push(order);
    return acc;
  }, {} as Record<string, { address: string; city: string; state: string; orders: WorkOrder[] }>);

  return Object.values(grouped);
}

export function AddressList({ showCompleted }: AddressListProps) {
  const { loading, error, data, setSelectedAddress } = useWorkOrdersStore();

  if (loading) {
    return <LoadingSkeleton />;
  }

  if (error) {
    return <ErrorState message={error} />;
  }

  const addressGroups = groupByAddress(data, showCompleted);

  if (data.length === 0) {
    return <EmptyState message="No work orders found" />;
  }

  return (
    <div className="space-y-6">
      {/* Address Grid */}
      {addressGroups.length === 0 ? (
        <EmptyState 
          message={showCompleted ? "No completed work orders" : "No active work orders"} 
        />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {addressGroups.map((group) => (
            <AddressCard
              key={group.address}
              addressGroup={group}
              onClick={() => setSelectedAddress(group.address)}
              isCompleted={showCompleted}
            />
          ))}
        </div>
      )}
    </div>
  );
}